import { render, staticRenderFns } from "./SendEgiftPanelRecipientsContacts.vue?vue&type=template&id=02ca57fb&scoped=true"
import script from "./SendEgiftPanelRecipientsContacts.vue?vue&type=script&lang=ts"
export * from "./SendEgiftPanelRecipientsContacts.vue?vue&type=script&lang=ts"
import style0 from "./SendEgiftPanelRecipientsContacts.vue?vue&type=style&index=0&id=02ca57fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ca57fb",
  null
  
)

export default component.exports